<template>
  <router-view/>
</template>

<script>
export default {
  mounted() {  
    // console.log(this.$store.getters.loggedIn)  
    // this.checkCache();
  },
  methods: {
    checkCache() {
      if(this.$store.getters.loggedIn) {
        let user_id = localStorage.getItem('user_id')
        let role = localStorage.getItem('role')
        let token = localStorage.getItem('access-token')
        let verify = localStorage.getItem('verify-token')

        if(user_id === null || role === null || token === null || verify === null) {
          if(this.$store.getters.loggedIn) {
            this.$store.dispatch('destroyToken')
            .then(response => {
              if(response.status == 200) {
                this.$nextTick(() => {
                  this.$router.push({
                    name: "login"
                  });
                });
              }
            })
          }
        }
      }
      else if(!this.$store.getters.loggedIn && this.$route.name !== "login") {
        this.$store.dispatch('destroyToken')
        .then(response => {
          if(response.status == 200) {
            this.$nextTick(() => {
              this.$router.push({
                name: "login"
              });
            });
          }
        })
      }
    }
  }
}
</script>
<style>
</style>
